var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { handleWidgetUpdate, renderForm } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetComponent } from '@juvare/widget-ui/WidgetComponent';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Accordion as MuiAccordion, AccordionDetails as MuiAccordionDetails, AccordionSummary as MuiAccordionSummary, Typography, styled, } from '@mui/material';
import React from 'react';
import { type } from './types';
const WidgetFilterPanel = (props) => {
    var _a;
    const children = (React.createElement(Box, { sx: {
            display: 'grid',
            gridTemplateColumns: (theme) => {
                var _a;
                return ({
                    xs: `100%`,
                    sm: ((_a = props.config.style) === null || _a === void 0 ? void 0 : _a.columns) === 2 ? `calc(50% - ${theme.spacing(1)}) calc(50% - ${theme.spacing(1)})` : undefined,
                });
            },
            gap: 2,
        } }, props.childProps &&
        props.childProps.length > 0 &&
        props.childProps.map((childProp) => (React.createElement(Box, { key: childProp.id, "data-widget": childProp.dataPath },
            React.createElement(WidgetComponent, Object.assign({}, childProp)))))));
    const label = props.config.label;
    if (label != null) {
        const chipCount = (_a = props.internalData.chipCount) !== null && _a !== void 0 ? _a : 0;
        const collapsed = !!props.internalData.collapsed;
        return (React.createElement(Accordion, { expanded: !collapsed, onChange: () => {
                props.internalData.collapsed = !collapsed;
                props.update();
                renderForm(props);
            }, "data-widget-type": type },
            React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreIcon, null) },
                React.createElement(Typography, { variant: 'subtitle1', sx: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } },
                    props.config.label,
                    chipCount > 0 ? ' (' + chipCount + ')' : '')),
            React.createElement(AccordionDetails, null, children)));
    }
    else {
        return (React.createElement(Box, { p: 2, "data-widget-type": type }, children));
    }
};
/**
 * Definition for the `filter.panel` widget.
 */
export const widgetFilterPanel = {
    type,
    update: (props) => {
        if (props.config.label != null && props.childProps) {
            let chipCount = 0;
            for (const childProp of props.childProps) {
                if (childProp.config.key) {
                    const data = childProp.getData();
                    if (Array.isArray(data)) {
                        chipCount += data.length;
                    }
                    else if (data != null && data !== false && data !== '') {
                        chipCount += 1;
                    }
                }
            }
            if (chipCount !== props.internalData.chipCount) {
                props.internalData.chipCount = chipCount;
                props.update();
            }
        }
        return handleWidgetUpdate(props);
    },
    childConfigs: (config) => config.children,
    component: WidgetFilterPanel,
};
const Accordion = styled((_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(MuiAccordion, Object.assign({ disableGutters: true, elevation: 0, square: true }, props), children));
})(() => ({}));
const AccordionSummary = styled((props) => React.createElement(MuiAccordionSummary, Object.assign({}, props)))(() => ({
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.066)', // have better color? mockups say "deprecated #EEEEEE"
    },
    '& .MuiAccordionSummary-content': {
        minWidth: 0,
    },
}));
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
}));
